import * as React from 'react';
import { styles } from './styles';
import { DesignBucketShell, DesignBucketShellProps } from '../components/DesignBucketShell';
import { DesignShowcaseSectionConfig } from '../../..';
import { capitalize } from 'utils/strings';
import { BaseButton } from '@routes/event/create/components/BaseButton';
import { RadioButton } from '@joykit';
import { InlineDialogProps } from '../../InlineDialog';
import { AlohaSVG } from './components/AlohaSVG';
import { BrannanSVG } from './components/BrannanSVG';

interface Props extends DesignShowcaseSectionConfig<string> {
  onOptionSelect: React.MouseEventHandler<HTMLElement>;
  onCloseRequest: InlineDialogProps<null>['onCloseRequest'];
  options: { label: string; value: string }[];
  isMobile?: boolean;
}

const getSVGForLayout = (layout: string): React.ComponentType<any> => {
  switch (layout) {
    case 'aloha':
      return AlohaSVG;
    case 'brannan':
      return BrannanSVG;
    default:
      return AlohaSVG;
  }
};

export class LayoutBucket extends React.Component<Props & DesignBucketShellProps> {
  render() {
    const valueString = this.props.values.map(capitalize).join(', ');
    return (
      <DesignBucketShell
        section="layout"
        isMobile={this.props.isMobile}
        label="Layout"
        open={this.props.open}
        onClose={this.props.onCloseRequest}
        subtitle={valueString}
        onTriggerClick={this.props.onTriggerClick}
        onResetClick={this.props.onResetClick}
      >
        <DesignBucketShell.Content className={styles.container}>
          {this.props.options.map((op, index) => {
            const Svg = getSVGForLayout(op.value);
            return (
              <div key={index} className={styles.frame}>
                <BaseButton
                  data-section="layout"
                  value={op.value}
                  onClick={this.props.onOptionSelect}
                  aria-label={`Toggle ${op.label}`}
                  className={styles.button}
                >
                  <div className={styles.optionContainer}>
                    <div className={styles.iconLabelWrapper}>
                      <Svg />
                      <span>{op.label}</span>
                    </div>
                    <RadioButton
                      name="layout"
                      data-section="layout"
                      value={op.value}
                      checked={this.props.values.includes(op.value)}
                    />
                  </div>
                </BaseButton>
              </div>
            );
          })}
        </DesignBucketShell.Content>
      </DesignBucketShell>
    );
  }
}
